import { render, staticRenderFns } from "./ProfileBadgesTab.vue?vue&type=template&id=7fbc64dd&scoped=true"
import script from "./ProfileBadgesTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileBadgesTab.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileBadgesTab.vue?vue&type=style&index=0&id=7fbc64dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc64dd",
  null
  
)

export default component.exports